var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1816_5047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 5.00015L7 3.00015M1.24998 10.7502L2.94217 10.5621C3.14891 10.5392 3.25229 10.5277 3.34891 10.4964C3.43463 10.4686 3.51621 10.4294 3.59143 10.3798C3.67621 10.3239 3.74976 10.2504 3.89685 10.1033L10.5 3.50015C11.0523 2.94787 11.0523 2.05244 10.5 1.50015C9.94771 0.947867 9.05228 0.947866 8.5 1.50015L1.89685 8.10329C1.74976 8.25038 1.67621 8.32392 1.6203 8.40871C1.5707 8.48393 1.53149 8.56551 1.50374 8.65123C1.47246 8.74785 1.46098 8.85122 1.438 9.05797L1.24998 10.7502Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1816_5047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.1a2a1b2a05e0102788dafd76e1fc0ab3.svg";
export { ForwardRef as ReactComponent };